import { localStoragePath } from '../utils'
import { UPDATE_MUTED_WIDGETS } from '../constants'

import userLocalStorage from 'live/lib/user-local-storage'

export default (dashboardId, widgetIds) => ({
    type: UPDATE_MUTED_WIDGETS,
    widgets: widgetIds.reduce(
        (mutedStatus, id) => ({
            ...mutedStatus,
            [id]: userLocalStorage.getItem(localStoragePath(dashboardId, id)) === 'true'
        }),
        {}
    )
})
